import styled from 'styled-components';
import IcoList from 'assets/images/2dMap/ico-list.svg';
import { PopupStyle } from '../_style';
import DashboardMaterialList from '../DashboardMaterialList';
import { DateObject } from 'react-multi-date-picker';
import { useState } from 'react';

const MaterialSt = {
  Wrap: styled.div`
    position: absolute;
    right: 167px;
    top: 16px;
    z-index: 1;
  `,
  Btn: styled.button`
    width: 106px;
    height: 42px;
    background-color: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    border: 1px solid #d5d5d5;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #242628;
    font-size: 14px;
    font-weight: 500;
    &:before {
      content: '';
      width: 24px;
      height: 24px;
      background: url(${IcoList}) no-repeat center;
    }
  `,
};

const MaterialList = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <MaterialSt.Wrap>
        <MaterialSt.Btn type="button" onClick={() => setIsOpen(true)}>
          자재 목록
        </MaterialSt.Btn>
      </MaterialSt.Wrap>
      {isOpen && (
        <>
          <PopupStyle.Dimmed></PopupStyle.Dimmed>
          <PopupStyle.Popup $width={1200}>
            <PopupStyle.Head $height={48} $align={'center'}>
              <PopupStyle.Title>자재 목록</PopupStyle.Title>
              <PopupStyle.CloseBtn $right={12} type={'button'} onClick={() => setIsOpen(false)}></PopupStyle.CloseBtn>
            </PopupStyle.Head>
            <PopupStyle.Cont style={{ height: 600 }}>
              <PopupStyle.Inner $padding={'20px 24px'} style={{ height: 'calc(100% - 40px)' }}>
                <DashboardMaterialList date={new DateObject()} />
              </PopupStyle.Inner>
            </PopupStyle.Cont>
          </PopupStyle.Popup>
        </>
      )}
    </>
  );
};

export default MaterialList;
